import React from 'react';
import './CompensationTable.css';

function CompensationTable({ language }) {
  const tableData = {
    kannada: {
      title: 'ಅನುಮೋದಿತ ಹೊಸ ಪರಿಹಾರದ ಆಯ್ಕೆಗಳು (ಪ್ರತಿ ಎಕರೆಗೆ)',
      columns: [
        {
          title: 'ನಗದು ಪರಿಹಾರ ',
          content: 'ಭೂಸ್ವಾಧೀನ ಕಾಯ್ದೆ- 1894 ರನ್ವಯ ಲಭ್ಯವಾಗುವ ಸಾಮಾನ್ಯ ಐ- ತೀರ್ಪಿನ ನಗದು ಪರಿಹಾರ ಮೊತ್ತ ಅಥವಾ ಗ್ರಾಮವಾರು ನಿಗದಿಪಡಿಸಿರುವ ಹೊಸ ಕಾಯ್ದೆಯ ತತ್ವಗಳ ಅನುಸಾರ ಸಂಧಾನಿತ ಪರಿಹಾರ ಮೊತ್ತ '
        },
        {
          title: 'ಅಭಿವೃದ್ಧಿಪಡಿಸಿದ ವಸತಿ ನಿವೇಶನಗಳು ',
          content: 'ಸಂಧಾನಿತ ಭೂ ಪರಿಹಾರ ಮೊತ್ತಕ್ಕೆ ಮೀರದ ಸಮಾನಾಂತರ ಮೌಲ್ಯವುಳ್ಳ ಡಾ.ಕೆ.ಶಿವರಾಮ ಕಾರಂತ ವಸತಿ ಬಡಾವಣೆ ಅಥವಾ ಪಿಆರ್ಆರ್- 1 ಸುತ್ತಮುತ್ತಲಿನ ವಸತಿ ಬಡಾವಣೆಗಳಲ್ಲಿ ವಸತಿ ನಿವೇಶನಗಳ ಪರಿಹಾರ '
        },
        {
          title: 'ಅಭಿವೃದ್ಧಿಪಡಿಸಿದ ವಾಣಿಜ್ಯ ನಿವೇಶನಗಳು ',
          content: '65:35 ಅನುಪಾತದಡಿ ಎಕರೆ ಒಂದಕ್ಕೆ 8,385 ಚದರ ಅಡಿ ಅಭಿವೃದ್ಧಿಪಡಿಸಿದ ವಾಣಿಜ್ಯ ನಿವೇಶನಗಳ ಪರಿಹಾರ '
        },
        {
          title: 'ಟಿ.ಡಿ.ಆರ್. ಅಥವಾ ಡಿ.ಆರ್.ಸಿ.',
          content: 'ಭೂಸ್ವಾಧೀನಕ್ಕೊಳಪಡುವ ಭೂಮಿಯು ಕೃಷಿ ಭೂಮಿಯಾಗಿದ್ದಲ್ಲಿ, ಕೃಷಿಯೇತರ ಭೂಮಿಯನ್ನಾಗಿ ಪರಿವರ್ತಿಸಲು ತಗಲುವ ಶುಲ್ಕವನ್ನು ಇನ್ನಿತರ ಶಾಸನಾತ್ಮಕ ಶುಲ್ಕಗಳನ್ನು ಪ್ರಾಧಿಕಾರವು ಪಾವತಿಸಿಕೊಂಡು ಸದರಿ ಕೃಷಿ ಭೂಮಿಗೆ ಅಭಿವೃದ್ಧಿ ಹೊಂದಿದ ವಸತಿ ಉದ್ದೇಶದ ನಿವೇಶನ ದರದಲ್ಲಿ ನೋಂದಣಿ ಮತ್ತು ಮುದ್ರಾಂಕ ಇಲಾಖೆಯ ಮಾರ್ಗಸೂಚಿ ದರಗಳನುಸಾರ ವರ್ಗಾವಣೆ ಮಾಡಬಹುದಾದ ಅಭಿವೃದ್ಧಿ ಹಕ್ಕುಗಳು(ಟಿ.ಡಿ.ಆರ್.)/ ಅಭಿವೃದ್ಧಿ ಹಕ್ಕುಪತ್ರ(D.R.C.) ನೀಡುವುದು.'
        },
        {
          title: 'ಮಹಡಿ ಪರಿಹಾರ (F.A.R.)',
          content: 'ಭೂಮಿ ಕಳೆದುಕೊಳ್ಳುವವರಿಗೆ ಉಳಿಕೆ ಹೊಂದಿಕೊಂಡಿರುವ ಜಮೀನಿನಲ್ಲಿ ಪರಿಷ್ಕೃತ ಮಹಾ ಯೋಜನೆ (RMP) - 2015 ನಿಯಮಗಳ ಪ್ರಕಾರ ಮಹಡಿ ಪರಿಹಾರ (F.A.R.)'
        }
      ],
      note: {
        title: 'ಸೂಚನೆ:',
        content: '0-20 ಗುಂಟೆಗಿಂತ ಕಡಿಮೆ ವಿಸ್ತೀರ್ಣವಿರುವ ಜಮೀನಿನ ಭೂಮಾಲೀಕರು ಭೂಸ್ವಾಧೀನ ಕಾಯ್ದೆ 1894ರಂತೆ ನೀಡಲಾಗುವ ನಗದು ಪರಿಹಾರ ಅಥವಾ ಸಂಧಾನಿತ ಐ-ತೀರ್ಪಿನ ನಗದು ಪರಿಹಾರ ಇವುಗಳಲ್ಲಿ ಯಾವುದಾದರೂ ಒಂದು ರೂಪದ ಪರಿಹಾರವನ್ನು ಆಯ್ಕೆ ಮಾಡಿಕೊಳ್ಳಬಹುದಾಗಿದೆ.'
      }
    },
    english: {
      title: 'Approved New Compensation Options (per acre)',
      columns: [
        {
          title: 'Cash Compensation',
          content: 'The cash compensation amount payable either as per the general award under the Land Acquisition Act, 1894, or the negotiated compensation amount determined in accordance with the principles of the new Act as fixed village-wise.'
        },
        {
          title: 'Developed Residential Plots',
          content: 'Allotment of residential plots of equivalent value, not exceeding the negotiated land compensation amount, in Dr. K. Shivarama Karanth Residential Layout or in residential layouts around PRR-1'
        },
        {
          title: 'Floor Area Ratio (FAR) Compensation',
          content: 'Grant of Floor Area Ratio (FAR) compensation to land losers on their adjoining remaining land, in accordance with the Revised Master Plan (RMP)-2015 regulations.'
        },
        {
          title: 'TDR or DRC',
          content: 'If the land to be acquired is agricultural land, the Authority shall bear/pay the land-conversion fees required to convert it into non-agricultural land along with other statutory charges, and issue Transferable Development Rights (TDR) / Development Rights Certificate (DRC) for the said agricultural land at the rate of a developed residential site in accordance with the guidance value prescribed by the Department of Stamps and Registration.'
        },
        {
          title: 'Developed Commercial Plots',
          content: 'Allotment of developed commercial plots measuring 8,385 sq.ft. per acre, under a 65:35 ratio'
        }
      ],
      note: {
        title: 'Note:',
        content: 'Landowners whose landholding is less than 20 guntas may choose any one form of compensation, either cash compensation awarded under the Land Acquisition Act, 1894, or cash compensation awarded through a negotiated consent award.'
      }
    }
  };

  const data = tableData[language];

  return (
    <div className="compensation-table-container">
      <h3 className="compensation-table-title">{data.title}</h3>
      <div className="compensation-table-wrapper">
        <table className="compensation-table">
          <thead>
            <tr>
              {data.columns.map((column, index) => (
                <th key={index} className="compensation-table-header">
                  {column.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {data.columns.map((column, index) => (
                <td key={index} className="compensation-table-cell">
                  {column.content}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
        <div className="compensation-table-note">
          <strong>{data.note.title}</strong> {data.note.content}
        </div>
      </div>
    </div>
  );
}

export default CompensationTable;
